import {
  ApiMarketplaceUser,
  MarketplaceUser,
  CreateMarketplaceUserParams,
  UpdateMarketplaceUserParams,
  ApiRailsContact,
  RailsContact,
} from '@types'
import { snakeCaseify } from '../../../utils'

interface EditMarketplaceUserCoordinator {
  RestService: {
    post: (
      url: string,
      params: CreateMarketplaceUserParams,
    ) => Promise<ApiMarketplaceUser>
    put: (
      url: string,
      params: UpdateMarketplaceUserParams,
    ) => Promise<ApiMarketplaceUser>
  }
  pResponseMarketplaceUser: (json: ApiMarketplaceUser) => MarketplaceUser
  HandleError: any
}
export const CreateMarketplaceUser = ({
  RestService,
  HandleError,
  pResponseMarketplaceUser,
}: EditMarketplaceUserCoordinator) => {
  return async (params: CreateMarketplaceUserParams) => {
    try {
      const response = await RestService.post(
        '/users/admin/create-marketplace-user',
        params,
      )

      return pResponseMarketplaceUser(response)
    } catch (error) {
      HandleError({ error })

      return null
    }
  }
}
export const UpdateMarketplaceUser = ({
  RestService,
  HandleError,
  pResponseMarketplaceUser,
}: EditMarketplaceUserCoordinator) => {
  return async (params: UpdateMarketplaceUserParams) => {
    try {
      const response = await RestService.put(
        '/users/admin/update-marketplace-user',
        params,
      )

      return pResponseMarketplaceUser(response)
    } catch (error) {
      HandleError({ error })

      return null
    }
  }
}

interface GetContactCoordinator {
  RestService: {
    get: (url: string, params: { email: string }) => Promise<ApiRailsContact>
  }
  pResponseContact: (json: ApiRailsContact) => RailsContact
}
export const GetContact = ({
  RestService,
  pResponseContact,
}: GetContactCoordinator) => {
  return async (email: string) => {
    try {
      const response = await RestService.get(
        '/api/admin/contacts/get_by_email',
        { email },
      )

      return pResponseContact(response)
    } catch (error) {
      return null
    }
  }
}

interface UnlinkAccountCoordinator {
  RestService: {
    post: (
      url: string,
      params: { accountId: string; marketplaceUserId: string },
    ) => Promise<boolean>
  }
  HandleError: any
}
export const UnlinkAccount = ({
  RestService,
  HandleError,
}: UnlinkAccountCoordinator) => {
  return async (accountId: string, marketplaceUserId: string) => {
    try {
      await RestService.post(
        '/api/admin/marketplace_users/unlink_account',
        snakeCaseify({ accountId, marketplaceUserId }),
      )

      return true
    } catch (error) {
      HandleError({ error })

      return false
    }
  }
}
